import type { SearchPlan } from '../services/smartSearchService'

/**
 * Under a search box while a sentence is being understood (2026-11-02).
 *
 * It used to go on to show what the sentence was understood as -- each tag
 * and word, with an x to take it off. Taken away (Huanrui, 2026-11-03): the
 * pieces read as the search, when the search is now also the whole phrase
 * against each picture's description, and the person's own words are what
 * they meant. Only "Understanding your search…" is left, for the second or
 * two it takes. `plan` and `onDrop` are kept so the pages need not change.
 */
export function SmartSearchChips({
  understanding,
}: {
  plan: SearchPlan | null
  understanding: boolean
  onDrop: (piece: { tag?: string; word?: string }) => void
}) {
  if (understanding) return <div className="ilib__understood ilib__understood--busy">Understanding your search…</div>
  return null
}
